import { useNavigate } from 'react-router-dom';
import HeroSection from '../components/Home/HeroSection';
import ServiceCards from '../components/Home/ServiceCards';
import WhyAGO from '../components/Home/WhyAGO';
import useSEO from '../utils/useSEO';

const HomePage = () => {
  const navigate = useNavigate();

  useSEO({
    title: 'AGO Innovations | Assignment Help, Student Services & Finance in India',
    description:
      'AGO Innovations – India\'s student services and finance marketplace. Assignment writing, journal writing, workshops, student earning programs, insurance advisory and investment planning.',
    keywords:
      'AGO Innovations, assignment writing service India, student earning, insurance advisory Mumbai, investment planning India, learn and earn, workshop for students',
    canonical: 'https://agoinnovations.in/',
  });

  const setActiveSection = (section) => {
    navigate(`/${section === 'home' ? '' : section}`);
  };

  return (
    <div>
      <HeroSection setActiveSection={setActiveSection} />
      <ServiceCards setActiveSection={setActiveSection} />
      <WhyAGO />
    </div>
  );
};

export default HomePage;